import React from 'react'
import SliderHomeReviews from '../../component/slidercomponent/SliderHomeReviews'

const HomeReviews = () => {
    return (
        <>

            <div className="testimonial-area ts-bg pt-80 pb-80" style={{marginTop:"-130px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div className="site-heading text-center">
                                <span className="site-title-tagline" style={{ color: "white" }}><i className="far fa-book-open-reader" /> Testimonials</span>
                                <h2 className="site-title text-white">What Our Students <span>Say's</span></h2>
                            </div>
                        </div>
                    </div>
                    <div className="testimonial-slider owl-carousel owl-theme owl-loaded owl-drag">
                        <div className="owl-stage-outer">
                            <SliderHomeReviews />

                            {/* <div className="owl-stage" style={{ transform: 'translate3d(-2075px, 0px, 0px)', transition: '0.25s', width: 3855 }}>
                                <div className="owl-item cloned" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/02.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Richard Lock</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item cloned" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/03.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Randal Grand</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item cloned" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/04.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Edward Miles</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item cloned" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/05.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Ninal Gordon</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/01.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Anthony Nicoll</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/02.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Richard Lock</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/03.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Randal Grand</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item active" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/04.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Edward Miles</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item active" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/05.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Ninal Gordon</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item cloned active" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/01.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Anthony Nicoll</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item cloned active" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/02.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Richard Lock</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item cloned" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/03.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Randal Grand</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                                <div className="owl-item cloned" style={{ width: '286.5px', marginRight: 10 }}>
                                    <div className="testimonial-item">
                                        <div className="testimonial-rate">
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                            <i className="fas fa-star" />
                                        </div>
                                        <div className="testimonial-quote">
                                            <p>
                                                There are many variations of tend to repeat chunks some all form necessary injected for the going are humour words.
                                            </p>
                                        </div>
                                        <div className="testimonial-content">
                                            <div className="testimonial-author-img">
                                                <img src="assets/img/testimonial/04.jpg" alt />
                                            </div>
                                            <div className="testimonial-author-info">
                                                <h4>Edward Miles</h4>
                                                <p>Student</p>
                                            </div>
                                        </div>
                                        <span className="testimonial-quote-icon"><i className="far fa-quote-right" /></span>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className="owl-nav disabled">
                            <button type="button" role="presentation" className="owl-prev"><span aria-label="Previous">‹</span></button>
                            <button type="button" role="presentation" className="owl-next"><span aria-label="Next">›</span></button>
                        </div>
                        <div className="owl-dots">
                            <button role="button" className="owl-dot active"><span /></button>
                            <button role="button" className="owl-dot"><span /></button>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default HomeReviews